<template>
  <div v-if="loading">loading...</div>
    <div v-else class="text-vc-blue-700 tw-text-sm font-bold flex">
      <i class="tw-icon user-regular-blue"/>
      <template v-if="hasPermission('permissions') && !hasPermission('manage_account')">
        {{contact.fullName}}
      </template>
      <template v-else>
        <a class="tw-link" :href="`/#/users/${nameValue}`">{{contact.full_name}}</a>
      </template>
    </div>
</template>
<script>
export default {
  props: {
    nameValue: {}
  },
  data: ()=>({
    loading: false,
    contact: { },
  }),
  watch: {
    nameValue: {
      handler(){
        if (!this.nameValue) return
        this.loading = true
        this.axios.get(`/agency_admin/users/${this.nameValue}`).then(resp => {
          this.loading = false
          this.contact = resp.data
        })
      },
      immediate: true
    }
  },
}
</script>